"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AfterModulesInstallationHook = exports.BeforeModulesInstallationHook = void 0;
const hooks_1 = require("../hooks");
/**
 * Hook executed before the installation of the modules
 */
class BeforeModulesInstallationHook extends hooks_1.BaseHook {
    constructor(sender, applicationContext, sortedModules) {
        super(sender);
        this.applicationContext = applicationContext;
        this.sortedModules = sortedModules;
    }
}
exports.BeforeModulesInstallationHook = BeforeModulesInstallationHook;
/**
 * Hook executed after the installation of the modules
 */
class AfterModulesInstallationHook extends hooks_1.BaseHook {
    constructor(sender, applicationContext, sortedModules) {
        super(sender);
        this.applicationContext = applicationContext;
        this.sortedModules = sortedModules;
    }
}
exports.AfterModulesInstallationHook = AfterModulesInstallationHook;
//# sourceMappingURL=hooks.js.map